import { ActionTree } from 'vuex';
import CategoriesState from '../types/CategoriesTypes'
import RootState from '@vue-storefront/core/types/RootState'
import rootStore from "@vue-storefront/core/store"
import { processURLAddress } from '@vue-storefront/core/helpers'
import config from 'config'
import fetch from 'isomorphic-fetch'

const actions: ActionTree<CategoriesState, RootState> = {
  setCategories ({ commit }, payload = { id: 0, topCategory: false }) {
    let location = rootStore.getters['locations/getActiveLocation']
    let partner = rootStore.getters['partners/getCurrentPartner']
    if (location && partner) {
      let locationCode = location.code
      let partnerCode = partner.code
      let indexName = `${config.elasticsearch.index}_category_${locationCode}`
      let parentId = payload.id === 0 ? partner.root_category_id : payload.id
      let url = processURLAddress(`/api/categories/getCategories?indexName=${indexName}&partnerCode=${partnerCode}&displayMode=${partner.display_mode}&sortBy=${partner.product_sort}&categoryId=${parentId}&size=1`)
      return fetch(url)
        .then(resp => resp.json())
        .then(categories => {
          if (payload.topCategory) {
            let category = categories.find(cat => cat.url_path === payload.topCategory)
            if (category) {
              let i = categories.indexOf(category);
              [categories[i], categories[0]] = [categories[0], categories[i]];
            }
          }

          categories = categories.map(item => {
            let categoryIds = [item.id];
            let childData = item.children_data;
            if (childData) {
              let recurGetIds = (childData) => {
                childData.map(child => {
                  categoryIds.push(child.id)
                  if (child.children_data) {
                    recurGetIds(child.children_data)
                  }
                })
              }
              recurGetIds(childData)
            }
            item.categoryIds = categoryIds
            return item
          })

          commit('updateCategories', categories)
          return categories
        })
    }
  },
  async loadProducts ({ state, dispatch }, payload= { id: 0, topCategory: false }) {
    let parentId = payload.id;
    if (parentId === 0) {
      let partner = rootStore.getters['partners/getCurrentPartner'];
      parentId = partner.root_category_id
    }
    if (!state.categoriesProducts.length) {
      return dispatch('setCategories', {id: parentId, store: payload.store, topCategory: payload.topCategory})
        .then(() => {
          let products = []
          products = state.categories.map(item => {
            let emptyProducts = {items: []};
            let categoryProductsCount = item.product_count
            let categoryIds = [item.id];
            let childData = item.children_data;
            if (childData) {
              let recurGetIds = (childData) => {
                childData.map(child => {
                  categoryProductsCount += child.product_count
                  categoryIds.push(child.id)
                  if (child.children_data) {
                    recurGetIds(child.children_data)
                  }
                })
              }
              recurGetIds(childData)
            }
            return {
              category: item,
              categoryIds: categoryIds,
              productsTotal: categoryProductsCount,
              products: emptyProducts
            }
          })
          return dispatch('setProducts', products)
        })
    }
  },
  setCategoriesLoaded ({ commit }, categoriesAmount) {
    commit('setCategoriesLoaded', categoriesAmount)
  },
  setProducts ({ commit }, payload) {
    commit('setProducts', payload)
  },
  updateProducts ({ state, commit, dispatch }, payload) {
    let { store, size, categoryIds, category } = payload
    let partner = rootStore.getters['partners/getCurrentPartner'];
    let location = rootStore.getters['locations/getActiveLocation'];
    let locationCode = location.code;
    let indexName = `${config.elasticsearch.index}_product_${locationCode}`;
    let from = 0;
    let exclude = config.entities.product.excludeFields

    let categoryProducts = state.categoriesProducts;

    let url = `/api/categories/loadProducts?indexName=${indexName}&partnerCode=${store}&categoryIds=${category.entity_id}&sortBy=${partner.product_sort}&size=${size}&from=${from}&exclude=${exclude}`
    return fetch(processURLAddress(url))
      .then(resp => resp.json())
      .then(products => {
        if (state.categoriesProducts.length === 0) {
          dispatch('setProducts', categoryProducts)
        }
        commit('updateProducts', {
          category,
          categoryIds: categoryIds,
          productsTotal: products.total,
          products: products.hits
        })

        return products
      })
  },
  cleanupSliderProducts ({ commit }) {
    commit('cleanupSliderProducts')
  }
}

export default actions
